export var HEADER_NAVIGATION_MENU_CONTENT_BODY_CLASS_PREFIX = 'HeaderNavigationMenuContentBody';
export var headerNavigationMenuContentBodyRoot = 'HeaderNavigationMenuContentBodyRoot';